// src/data/personalizedReports.js
const personalizedReports = [
  { id: 1, title: "Daily Report", link: "/personalized/daily" },
  { id: 2, title: "Weekly Report", link: "/personalized/weekly" },
  { id: 3, title: "Monthly Report", link: "/personalized/monthly" },
  { id: 4, title: "Yearly Report", link: "/personalized/yearly" },
  { id: 5, title: "Love & Relationship", link: "/personalized/love" },
  { id: 6, title: "Career Guidance", link: "/personalized/career" },
  { id: 7, title: "Health Report", link: "/personalized/health" },
  { id: 8, title: "Finance Report", link: "/personalized/finance" },
  { id: 9, title: "Education Report", link: "/personalized/education" },
  { id: 10, title: "Property Report", link: "/personalized/property" },
  { id: 11, title: "Child Name Suggestion", link: "/personalized/child-name" }
]

export default personalizedReports